import { BaseAPIModel, fetcher } from '@weezevent/weezjs-core';

export default class InternalResaleSettingsModel extends BaseAPIModel {
    fields() {
        return {
            enable_private_resale: {},
            enabled_share_link: {},
            share_link_template: {},
            identity_id: {},
            template_id_ticket_on_resale: {},
            notify_ticket_on_resale: {},
            template_id_ticket_resold: {},
            notify_ticket_resold: {},
            default_resale_widget: { default: null },
            host_resale_link: { default: null }
        };
    }

    static save(data, method, { organizationId, eventId }) {
        const url = this.listUrl({ organizationId, eventId });
        return fetcher[method](url, {
            data: {
                data
            }
        });
    }

    static listUrl({ organizationId, eventId }) {
        if (!organizationId || !eventId) {
            throw new Error('[InternalResaleSettingsModel] organizationId and eventId are required');
        }
        return `/ticket/organizations/${organizationId}/events/${eventId}/internal/resale/settings`;
    }

    static list(item) {
        return item;
    }

    static getIdentities({ organizationId, eventId }) {
        if (!organizationId || !eventId) {
            throw new Error('[InternalResaleSettingsModel] organizationId and eventId are required');
        }
        return this.fetcher.get(`${this.listUrl({ organizationId, eventId })}/identities`);
    }

    static getTemplates({ organizationId, eventId }) {
        if (!organizationId || !eventId) {
            throw new Error('[InternalResaleSettingsModel] organizationId and eventId are required');
        }
        return this.fetcher.get(`${this.listUrl({ organizationId, eventId })}/templates`);
    }
}
